export default __webpack_public_path__ + "static/media/bdswissGlobalReal05_downloadMT4.918a1774.png";